import { Order } from '@/api/spec';
import { ViewOrder } from '@/feature/order_entry/ViewOrder.ts';
import { OrderAction, orderStatusMapper } from '@/feature/order_entry/order_types.ts';
import { MarketData } from '@/common/MarketData.ts';
import { getOrderDisplayType } from '../../account/utils/getOrderDisplayType';
import { deriveOrderFields, scaleValue } from '../../account/utils/scaleOrderFields';

export function mapOrderToViewOrder(order: Order, marketsMap?: ReadonlyMap<number, MarketData>): ViewOrder {
  const market = marketsMap?.get(order.mkt);
  const { side, isClose, isBuy, assetDecimals, quoteDecimals, assetCurrency } = deriveOrderFields(order.t, market);

  const action = isClose ? OrderAction.close : OrderAction.open;
  const remainingSize = order.os - order.fs;

  const scaledPrice = scaleValue(order.p, quoteDecimals, 0);
  const scaledFillPrice = scaleValue(order.fp, quoteDecimals, 0);
  const scaledSize = scaleValue(remainingSize, assetDecimals, 0);
  const scaledOriginalSize = scaleValue(order.os, assetDecimals, 0);
  const orderValue = scaledPrice * scaledSize;
  const triggerPrice = scaleValue(order.tp, quoteDecimals);

  const orderType = getOrderDisplayType(order.t, scaledPrice, triggerPrice);

  return {
    oid: order.oid,
    scid: order.scid,
    dateTimestamp: order.c.t,
    txHash: order.c.txid,
    type: orderType,
    assetCurrency,
    marketId: order.mkt,
    assetDecimals,
    quoteDecimals,
    side,
    action,
    isClose,
    isBuy,
    size: scaledSize,
    originalSize: scaledOriginalSize,
    price: scaledPrice,
    fillingPrice: scaledFillPrice,
    orderValue: orderValue || undefined,
    reduceOnly: isClose,
    triggerPrice,
    triggerCondition: order.tpc,
    takeProfit: undefined,
    stopLoss: undefined,
    status: orderStatusMapper[order.st],
    statusReason: order.sr,
    failureReason: order.fr,
  };
}
